import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AppEnvironmentConfig } from '../../../environments/environment.model';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  static getVariable<T>(name: string): T {
    return environment[name];
  }
  static getVariables(): AppEnvironmentConfig {
    return environment;
  }
}
